import React from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";

export default function PreviewCard(props) {
  const {
    borderColor,
    data: { skills, label },
    setSkillModalData,
  } = props;

  const {t} = useTranslation("reading_rope_report")

  const isSR = label === "Structure & Reasoning";

  return (
    <div className="preview-card">
      <div className="pc-inner">
        <div className="pc-skills-section">
            <div className="pc-title" style={{ background: borderColor }}>
              {t(label)}
            </div>
          <div className="pc-skills-wrapper">{renderSkills()}</div>
          {!isSR && (
            <div className="view-button-wrapper">
              <div
                className="view-button hover-opacity"
                onClick={props.onClick}
              >
                {t("View Details")}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  function renderSkills() {
    const handleClick = (skill) => {
      setSkillModalData(skill);
    };

    if (skills && skills.length > 0)
      return (
        <div className="pc-skills-wrapper-2">
          {skills.slice(0, 3).map((skill, i) => (
            <div className="pc-skill-row" key={i}>
              <div className="pc-skill-num">{i + 1}.</div>
              <div onClick={() => handleClick(skill)}>{skill.skillName}</div>
            </div>
          ))}
        </div>
      );

    if (isSR)
      return <div className="pc-coming-soon">{t("Skills Coming Soon...")}</div>;
  }
}
